import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Button from "../../../common/Button/index.jsx";
import AppContext from "../../../../AppContext.jsx";
import {
  bankList,
  langComponent,
  PAGE_STATE,
} from "../../../../constants/index.jsx";

import ProfileContext from "../../ProfileContext.jsx";
import Switch from "react-switch";
import View from "./View.jsx";
import useBankAccount from "../../../../hooks/useBankAccount.js";

import List, { STATE } from "../../../List/index";
import SecondaryPagination from "../../../SecondaryPagination/SecondaryPagination.jsx";
import { ReactComponent as WarningSvg } from "../../../../assets/icons/warning.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/profile/delete.svg";
import { ReactComponent as CheckSvg } from "../../../../assets/icons/chack.svg";
import { ReactComponent as BaacSvg } from "../../../../assets/omise/baac.svg";
import { ReactComponent as BaySvg } from "../../../../assets/omise/bay.svg";
import { ReactComponent as BblSvg } from "../../../../assets/omise/bbl.svg";
import { ReactComponent as BnpSvg } from "../../../../assets/omise/bnp.svg";
import { ReactComponent as BoaSvg } from "../../../../assets/omise/boa.svg";
import { ReactComponent as CacibSvg } from "../../../../assets/omise/cacib.svg";
import { ReactComponent as CimbSvg } from "../../../../assets/omise/cimb.svg";
import { ReactComponent as CitiSvg } from "../../../../assets/omise/citi.svg";
import { ReactComponent as DbSvg } from "../../../../assets/omise/db.svg";
import { ReactComponent as GhbSvg } from "../../../../assets/omise/ghb.svg";
import { ReactComponent as GsbSvg } from "../../../../assets/omise/gsb.svg";
import { ReactComponent as HsbcSvg } from "../../../../assets/omise/hsbc.svg";
import { ReactComponent as IbankSvg } from "../../../../assets/omise/ibank.svg";
import { ReactComponent as Icbcvg } from "../../../../assets/omise/icbc.svg";
import { ReactComponent as JmpSvg } from "../../../../assets/omise/jpm.svg";
import { ReactComponent as KbankSvg } from "../../../../assets/omise/kbank.svg";
import { ReactComponent as KkSvg } from "../../../../assets/omise/kk.svg";
import { ReactComponent as KtbSvg } from "../../../../assets/omise/ktb.svg";
import { ReactComponent as LhbSvg } from "../../../../assets/omise/lhb.svg";
import { ReactComponent as MbSvg } from "../../../../assets/omise/mb.svg";
import { ReactComponent as MegaSvg } from "../../../../assets/omise/mega.svg";
import { ReactComponent as MufgSvg } from "../../../../assets/omise/mufg.svg";
import { ReactComponent as RbsSvg } from "../../../../assets/omise/rbs.svg";
import { ReactComponent as ScSvg } from "../../../../assets/omise/sc.svg";
import { ReactComponent as ScbSvg } from "../../../../assets/omise/scb.svg";
import { ReactComponent as SmbcSvg } from "../../../../assets/omise/smbc.svg";
import { ReactComponent as TbankSvg } from "../../../../assets/omise/tbank.svg";
import { ReactComponent as TcrbSvg } from "../../../../assets/omise/tcrb.svg";
import { ReactComponent as TiscoSvg } from "../../../../assets/omise/tisco.svg";
import { ReactComponent as TmbSvg } from "../../../../assets/omise/tmb.svg";
import { ReactComponent as TtbSvg } from "../../../../assets/omise/ttb.svg";
import { ReactComponent as UobSvg } from "../../../../assets/omise/uob.svg";
import { toast } from "react-toastify";
import Overlay from "../../../Overlay/index.jsx";

const prefix = "profile-edit-billing-account";

const columns = [
  {
    display: "Account Number",
    key: "accountNo",
    textAlign: "left",
    maxWidth: 120,
  },
  {
    display: "Name",
    key: "name",
    textAlign: "left",
    maxWidth: 200,
  },
  {
    display: "Bank",
    key: "brand",
    textAlign: "left",
    maxWidth: 160,
  },
  {
    display: "Verified",
    key: "verified",
    textAlign: "left",
    maxWidth: 48,
  },
  {
    display: "Active",
    key: "active",
    textAlign: "left",
    maxWidth: 48,
  },
  {
    display: "",
    key: "actions",
    textAlign: "left",
    maxWidth: 32,
  },
];

const BankAccount = (props) => {
  const { getLang } = useContext(AppContext);
  const { user } = useContext(ProfileContext);
  const Translation = getLang(langComponent.project);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const { queryBankAccounts, patchBankAccounts, deleteBankAccounts } =
    useBankAccount();
  const TranslationCommon = getLang(langComponent.common);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [toggleModal, setToggleModal] = useState(false);
  const [selected, setSelected] = useState(undefined);
  const [metadata, setMetaData] = useState(undefined);
  const [deleteModal, setDeleteModal] = useState(undefined);

  const [details, setDetail] = useState({
    bank: "",
  });

  const _getBankIcon = (name) => {
    if (name === "bbl") return <BblSvg width={20} />;
    if (name === "kbank") return <KbankSvg width={20} />;
    if (name === "rbs") return <RbsSvg width={20} />;
    if (name === "ktb") return <KtbSvg width={20} />;
    if (name === "jpm") return <JmpSvg width={20} />;
    if (name === "mufg") return <MufgSvg width={20} />;
    if (name === "tmb") return <TmbSvg width={20} />;
    if (name === "scb") return <ScbSvg width={20} />;
    if (name === "citi") return <CitiSvg width={20} />;
    if (name === "smbc") return <SmbcSvg width={20} />;
    if (name === "sc") return <ScSvg width={20} />;
    if (name === "cimb") return <CimbSvg width={20} />;
    if (name === "uob") return <UobSvg width={20} />;
    if (name === "bay") return <BaySvg width={20} />;
    if (name === "mega") return <MegaSvg width={20} />;
    if (name === "boa") return <BoaSvg width={20} />;
    if (name === "cacib") return <CacibSvg width={20} />;
    if (name === "gsb") return <GsbSvg width={20} />;
    if (name === "hsbc") return <HsbcSvg width={20} />;
    if (name === "db") return <DbSvg width={20} />;
    if (name === "ghb") return <GhbSvg width={20} />;
    if (name === "baac") return <BaacSvg width={20} />;
    if (name === "mb") return <MbSvg width={20} />;
    if (name === "tbank") return <TbankSvg width={20} />;
    if (name === "bnp") return <BnpSvg width={20} />;
    if (name === "ibank") return <IbankSvg width={20} />;
    if (name === "tisco") return <TiscoSvg width={20} />;
    if (name === "kk") return <KkSvg width={20} />;
    if (name === "icbc") return <Icbcvg width={20} />;
    if (name === "tcrb") return <TcrbSvg width={20} />;
    if (name === "lhb") return <LhbSvg width={20} />;
    if (name === "ttb") return <TtbSvg width={20} />;

    return null; // Return null if no match found
  };

  const handleOnPageChange = (page) => setPage(page);

  const handleOnLimitChange = (limit) => {
    setPage(1);
    setLimit(limit);
  };

  const handelUpdateAccount = async (id, data, active) => {
    const payload = { ...data, active };
    const response = await patchBankAccounts(id, payload);
    if (response)
      toast.success(`Update Bank Account Success`, { position: "top-right" });
    await fetchData();
  };

  const handleViewClose = async () => {
    setSelected(undefined);
    setToggleModal(false);
    await fetchData();
  };

  const handleSuccess = async (data) => {
    setToggleModal(false);
    await fetchData();
    toast.success(`Create Bank Account Success`, { position: "top-right" });
  };

  const handleClick = (_id) => {
    setSelected(_id);
  };

  const [accountList, setAccountList] = useState([]);

  const fetchData = async () => {
    const { data, _metadata } = await queryBankAccounts(
      { user: user._id, active: true, deleted: false },
      page,
      limit
    );

    setAccountList(
      data.map((item) => {
        const {
          _id,
          verified,
          active,
          bank: { name, brand, accountNo },
        } = item;

        let _bankName = "";

        for (const key in bankList.th) {
          if (key !== brand) continue;

          const element = bankList.th[key];

          _bankName = element.nice_name;
          break;
        }

        return {
          _id: _id,
          brand: (
            <div className={`${prefix}-list-item-bank`}>
              {_getBankIcon(brand)}
              <span>{_bankName}</span>
            </div>
          ),
          name,
          accountNo,
          verified: verified ? <CheckSvg /> : "",
          active: (
            <Switch
              checked={active}
              onChange={(value) => {
                handelUpdateAccount(_id, item, value);
              }}
              onColor="#013565"
              onHandleColor="#FFF"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={24}
              width={36}
              className="react-switch"
              id={`switch-${_id}`}
            />
          ),
          actions: (
            <div
              className={`${prefix}-list-item-actions`}
              // onClick={() => handleClick(item._id)}
            >
              <DeleteSvg
                width={24}
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteModal(_id);
                }}
              />
            </div>
          ),
        };
      })
    );
    setMetaData(_metadata);
  };

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  useEffect(() => {
    fetchData();
  }, [limit, page]);

  useEffect(() => {
    setPageState(PAGE_STATE.IDLE);
    fetchData();
    return () => {};
  }, []);

  useEffect(() => {
    if (selected) {
      setToggleModal(true);
    }
  }, [selected]);

  if (pageState !== PAGE_STATE.IDLE) {
    return <h1>Loading...</h1>;
  }

  const _getModalDelete = () => {
    // * Get work from datasource
    const _account = accountList.find((project) => project._id === deleteModal);

    return (
      <Overlay
        onClose={() => {
          setDeleteModal(undefined);
        }}
        style={{
          alignItems: "flex-start",
        }}
      >
        <div className={`${prefix}-delete`}>
          <WarningSvg width={64} />
          <p className={`${prefix}-delete__header`}>
            {TranslationCommon(`Delete ${_account.accountNo}?`)}
          </p>
          <div className={`${prefix}-delete__action`}>
            <Button
              variant={"secondary"}
              label={"Cancel"}
              onClick={() => setDeleteModal(undefined)}
            />
            <Button
              label={"Confirm"}
              onClick={() => {
                deleteBankAccounts(_account._id)
                  .then((result) => {
                    fetchData();
                    setDeleteModal(undefined);
                    toast.info(`Deleted account ${_account.accountNo}`);
                  })
                  .catch((err) => {
                    toast.error("Unable to delete bank account");
                  });
              }}
            />
          </div>
        </div>
      </Overlay>
    );
  };

  const AccountList = () => {
    return (
      <List
        contentState={pageState}
        columns={columns}
        dataSource={accountList ?? []}
        viewable={true}
        enableSelection={false}
        enableSelectionHeader={false}
        onRecordClick={(e) => handleClick(e._id)}
      >
        <SecondaryPagination
          limits={[10, 50]}
          defaultPage={metadata?.currentPage || 1}
          pages={metadata?.totalPages || 1}
          defaultLimit={metadata?.pageSize}
          onPageChange={handleOnPageChange}
          onLimitChange={handleOnLimitChange}
        />
      </List>
    );
  };

  return (
    <div className={prefix}>
      <div className={`${prefix}-header`}>
        <span className="profile-edit-billing__heading">Bank Accounts</span>
        <Button
          label={TranslationCommon("Add")}
          variant={"primary"}
          onClick={() => setToggleModal(true)}
        />
      </div>
      <div className={`${prefix}-content`}>
        <AccountList />
        {toggleModal && (
          <View
            onClose={handleViewClose}
            onSuccess={handleSuccess}
            editing={selected}
          />
        )}
      </div>
      {deleteModal && _getModalDelete()}
    </div>
  );
};

BankAccount.propTypes = {
  _id: PropTypes.string,
};

BankAccount.defaultProps = {
  _id: undefined,
};

export default BankAccount;
